webpackJsonp([0],{

/***/ "7jQq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.8451124.jpg";

/***/ }),

/***/ "7xNN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3.0b46459.mp3";

/***/ }),

/***/ "8FcD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.9cf85af.jpg";

/***/ }),

/***/ "CtaL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.4f815d7.jpg";

/***/ }),

/***/ "DeB9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.192b316.jpg";

/***/ }),

/***/ "E3o5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Erzt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.fb69c4a.jpg";

/***/ }),

/***/ "HYh8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LeiF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MNtS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.8a0ebd1.jpg";

/***/ }),

/***/ "Mn6R":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.82b6184.jpg";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./src/assets/music/1.mp3
var _ = __webpack_require__("fSgI");
var __default = /*#__PURE__*/__webpack_require__.n(_);

// EXTERNAL MODULE: ./src/assets/music/2.mp3
var music_2 = __webpack_require__("m2cP");
var music_2_default = /*#__PURE__*/__webpack_require__.n(music_2);

// EXTERNAL MODULE: ./src/assets/music/3.mp3
var music_3 = __webpack_require__("7xNN");
var music_3_default = /*#__PURE__*/__webpack_require__.n(music_3);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//





/* harmony default export */ var App = ({
  name: 'app',
  data: function data() {
    return {
      cake_mp3_url: music_2_default.a,
      img_mp3_url: music_3_default.a,
      memory_mp3_url: __default.a
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//





/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  data: function data() {
    return {
      cake_mp3_url: music_2_default.a,
      img_mp3_url: music_3_default.a,
      memory_mp3_url: __default.a
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-558fe919","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('audio',{attrs:{"id":"cake-music","src":_vm.cake_mp3_url,"loop":"loop"}}),_vm._v(" "),_c('audio',{attrs:{"id":"img-music","src":_vm.img_mp3_url,"loop":"loop"}}),_vm._v(" "),_c('audio',{attrs:{"id":"memory-music","src":_vm.memory_mp3_url,"loop":"loop"}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("ili8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Login = ({
  components: {},
  data: function data() {
    return {
      username: '',
      password: ''
    };
  },

  methods: {
    btnclick: function btnclick() {
      if (this.username === 'ljz' && this.password === '0620') {
        jquery_default()('audio#cake-music')[0].play();
        var url = '/cake';
        this.$router.push({ path: url });
      } else {
        alert('用户名或密码不正确！');
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_Login = ({
  components: {},
  data: function data() {
    return {
      username: '',
      password: ''
    };
  },

  methods: {
    btnclick: function btnclick() {
      if (this.username === 'ljz' && this.password === '0620') {
        jquery_default()('audio#cake-music')[0].play();
        var url = '/cake';
        this.$router.push({ path: url });
      } else {
        alert('用户名或密码不正确！');
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6878b84a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"htmleaf-container"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"container"},[_c('h1',{attrs:{"id":"h"}}),_vm._v(" "),_c('form',{staticClass:"form"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"name":"userName","type":"text","placeholder":"姓名字母缩写"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"name":"pwd","type":"password","placeholder":"密码生日(如0101)"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{attrs:{"type":"button"},on:{"click":_vm.btnclick}},[_vm._v("进入")])])]),_vm._v(" "),_vm._m(0)])])}
var Login_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"bg-bubbles"},[_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li')])}]
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/components/Login.vue
function Login_injectStyle (ssrContext) {
  __webpack_require__("HYh8")
}
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = Login_injectStyle
/* scopeId */
var Login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  components_Login,
  selectortype_template_index_0_src_components_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var src_components_Login = (Login_Component.exports);

// EXTERNAL MODULE: ./src/assets/img/HappyBirthday.png
var HappyBirthday = __webpack_require__("yFNT");
var HappyBirthday_default = /*#__PURE__*/__webpack_require__.n(HappyBirthday);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Cake.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Cake = ({
  components: {},
  data: function data() {
    return {
      msg: 'Hello World!',
      png_url: HappyBirthday_default.a
    };
  },

  methods: {
    btnclick: function btnclick() {
      jquery_default()('#ILove').remove();
      jquery_default()('#isLike').append('<div class="lk1" id="ILove" style=" opacity:0;font-size:10px;color:yellow;" >\u7B97\u4F60\u6709\u773C\u5149\u54C8\uFF01</div>');
      jquery_default()('#ILove').animate({
        opacity: '1',
        fontSize: '30px'
      }, 300);
      setTimeout(this.jump, 3000);
    },
    jump: function jump() {
      jquery_default()('audio#cake-music')[0].pause();
      jquery_default()('audio#img-music')[0].play();
      var url = '/img';
      this.$router.push({ path: url });
    }
  },
  mounted: function mounted() {
    setTimeout(function () {
      jquery_default()('.name').animate({
        opacity: '1',
        top: '15%'
      }, 2000);
    }, 6000);
    setTimeout(function () {
      jquery_default()('.happy').animate({
        opacity: '1',
        top: '15%'
      }, 2000);
    }, 6000);
    setTimeout(function () {
      jquery_default()('.button-style1:not(#isLike)').animate({
        opacity: '1',
        top: '80%'
      }, 1500);
    }, 9000);
    setTimeout(function () {
      jquery_default()('#isLike').animate({
        opacity: '1',
        top: '60%'
      }, 1500);
    }, 7000);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Cake.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_Cake = ({
  components: {},
  data: function data() {
    return {
      msg: 'Hello World!',
      png_url: HappyBirthday_default.a
    };
  },

  methods: {
    btnclick: function btnclick() {
      jquery_default()('#ILove').remove();
      jquery_default()('#isLike').append('<div class="lk1" id="ILove" style=" opacity:0;font-size:10px;color:yellow;" >\u7B97\u4F60\u6709\u773C\u5149\u54C8\uFF01</div>');
      jquery_default()('#ILove').animate({
        opacity: '1',
        fontSize: '30px'
      }, 300);
      setTimeout(this.jump, 3000);
    },
    jump: function jump() {
      jquery_default()('audio#cake-music')[0].pause();
      jquery_default()('audio#img-music')[0].play();
      var url = '/img';
      this.$router.push({ path: url });
    }
  },
  mounted: function mounted() {
    setTimeout(function () {
      jquery_default()('.name').animate({
        opacity: '1',
        top: '15%'
      }, 2000);
    }, 6000);
    setTimeout(function () {
      jquery_default()('.happy').animate({
        opacity: '1',
        top: '15%'
      }, 2000);
    }, 6000);
    setTimeout(function () {
      jquery_default()('.button-style1:not(#isLike)').animate({
        opacity: '1',
        top: '80%'
      }, 1500);
    }, 9000);
    setTimeout(function () {
      jquery_default()('#isLike').animate({
        opacity: '1',
        top: '60%'
      }, 1500);
    }, 7000);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45076d76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cake.vue
var Cake_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cake-container"},[_c('div',{staticClass:"bg"},[_vm._m(0),_vm._v(" "),_c('svg',{attrs:{"id":"cake","version":"1.1","x":"0px","y":"0px","width":"200px","height":"500px","viewBox":"0 0 200 500","enable-background":"new 0 0 200 500","xml:space":"preserve"}},[_c('path',{attrs:{"fill":"#a88679","d":"M173.667-13.94c-49.298,0-102.782,0-147.334,0c-3.999,0-4-16.002,0-16.002\n          c44.697,0,96.586,0,147.334,0C177.667-29.942,177.668-13.94,173.667-13.94z"}},[_c('animate',{attrs:{"id":"bizcocho_3","attributeName":"d","calcMode":"spline","keySplines":"0 0 1 1; 0 0 1 1","begin":"relleno_2.end","dur":"0.3s","fill":"freeze","values":"\n                                M173.667-13.94c-49.298,0-102.782,0-147.334,0c-3.999,0-4-16.002,0-16.002\n          c44.697,0,96.586,0,147.334,0C177.667-29.942,177.668-13.94,173.667-13.94z\n                                ;\n                                M173.667,411.567c-47.995,12.408-102.955,12.561-147.334,0\n          c-3.848-1.089-0.189-16.089,3.661-15.002c44.836,12.66,90.519,12.753,139.427,0.07\n          C173.293,395.631,177.541,410.566,173.667,411.567z\n                                ;\n                                M173.667,427.569c-49.795,0-101.101,0-147.334,0c-3.999,0-4-16.002,0-16.002\n          c46.385,0,97.539,0,147.334,0C177.668,411.567,177.667,427.569,173.667,427.569z\n                                "}})]),_vm._v(" "),_c('path',{attrs:{"fill":"#8b6a60","d":"M100-178.521c1.858,0,3.364,1.506,3.364,3.363c0,0,0,33.17,0,44.227\n          c0,19.144,0,57.431,0,76.574c0,10.152,0,40.607,0,40.607c0,1.858-1.506,3.364-3.364,3.364l0,0c-1.858,0-3.364-1.506-3.364-3.364c0,0,0-30.455,0-40.607c0-19.144,0-57.432,0-76.575c0-11.057,0-44.226,0-44.226C96.636-177.015,98.142-178.521,100-178.521\n          L100-178.521z"}},[_c('animate',{attrs:{"id":"relleno_2","attributeName":"d","calcMode":"spline","keySplines":"0 0 1 1; 0 0 1 1; 0 0 0.58 1","begin":"bizcocho_2.end","dur":"0.5s","fill":"freeze","values":"\n                                M100-178.521c1.858,0,3.364,1.506,3.364,3.363c0,0,0,33.17,0,44.227\n          c0,19.144,0,57.431,0,76.574c0,10.152,0,40.607,0,40.607c0,1.858-1.506,3.364-3.364,3.364l0,0c-1.858,0-3.364-1.506-3.364-3.364c0,0,0-30.455,0-40.607c0-19.144,0-57.432,0-76.575c0-11.057,0-44.226,0-44.226C96.636-177.015,98.142-178.521,100-178.521\n          L100-178.521z\n                                ;\n                                M100,267.257c1.858,0,3.364,1.506,3.364,3.363c0,0,0,33.17,0,44.227\n          c0,19.143,0,57.43,0,76.574c0,10.151,0,40.606,0,40.606c0,1.858-1.506,3.364-3.364,3.364l0,0c-1.858,0-3.364-1.506-3.364-3.364\n          c0,0,0-30.455,0-40.606c0-19.145,0-57.432,0-76.576c0-11.057,0-44.225,0-44.225C96.636,268.763,98.142,267.257,100,267.257\n          L100,267.257z\n                                ;\n                                M93.928,405.433c-0.655,6.444-0.102,9.067,2.957,11.798c0,0,8.083,5.571,16.828,3.503\n          c18.629-4.406,43.813,6.194,50.792,7.791c14.75,3.375,9.162,6.867,9.162,6.867c-2.412,2.258-58.328,0-73.667,0l0,0\n          c-1.858,0-69.995,2.133-73.667,0c0,0-3.337-2.439,6.172-5.992c11.375-4.25,52.875,8.822,47.139-9.442\n          c-6.333-20.167,5.226-21.514,5.226-21.514c3.435-0.915,12.78-6.663,10.923-0.546L93.928,405.433z\n                                ;\n                                M102.242,427.569c5.348,0,14.079,0,17.462,0c0,0,17.026,0,27.504,0\n          c19.143,0,20.39-3.797,26.459,0c3,1.877,0,7.823,0,7.823c-2.412,2.258-58.328,0-73.667,0l0,0c-1.858,0-67.187,0-73.667,0\n          c0,0-4.125-4.983,0-7.823c5.201-3.58,16.085,0,23.725,0c8.841,0,20.762,0,20.762,0c3.686,0,8.597,0,19.511,0H102.242z\n                                "}})]),_vm._v(" "),_c('path',{attrs:{"fill":"#a88679","d":"M173.667-15.929c-46.512,0-105.486,0-147.334,0c-3.999,0-4-16.002,0-16.002\n          c43.566,0,97.96,0,147.334,0C177.667-31.931,177.666-15.929,173.667-15.929z"}},[_c('animate',{attrs:{"id":"bizcocho_2","attributeName":"d","calcMode":"spline","keySplines":"0 0 1 1; 0 0 1 1; 0.25 0 0.58 1","begin":"relleno_1.end","dur":"0.5s","fill":"freeze","values":"\n                                M173.667-15.929c-46.512,0-105.486,0-147.334,0c-3.999,0-4-16.002,0-16.002\n          c43.566,0,97.96,0,147.334,0C177.667-31.931,177.666-15.929,173.667-15.929z\n                                ;\n                                M173.434,445.393c-47.269,8.001-105.245,8.001-147.334,0c-3.929-0.747-0.692-16.543,3.243-15.824\n          c43.828,8.001,92.165,8.001,140.739,0C174.029,428.918,177.377,444.726,173.434,445.393z\n                                ;\n                                M173.667,449.514c-47.576-5.454-102.799-5.744-147.333,0c-3.966,0.512-3.938-15.297,0-16.002\n          c43.683-7.823,97.646-8.026,147.333,0C177.616,434.15,177.642,449.969,173.667,449.514z\n                                ;\n                                M173.667,451.394c-49.298,0-102.782,0-147.334,0c-3.999,0-4-16.002,0-16.002\n          c44.697,0,96.586,0,147.334,0C177.667,435.392,177.668,451.394,173.667,451.394z\n                                "}})]),_vm._v(" "),_c('path',{attrs:{"fill":"#8b6a60","d":"M101.368-73.685c0,12.164,0,15.18,0,28.519c0,22.702,0-13.661,0,8.304c0,14.48,0,18.233,0,30.512\n          c0,1.753-2.958,1.847-2.958,0c0-12.68,0-16.277,0-30.401c0-21.983,0,11.66,0-8.305c0-13.027,0-15.992,0-28.628\n          C98.411-75.883,101.368-75.592,101.368-73.685z"}},[_c('animate',{attrs:{"id":"relleno_1","attributeName":"d","calcMode":"spline","keySplines":"0 0 1 1; 0 0 1 1; 0 0 0.6 1","begin":"bizcocho_1.end","dur":"0.5s","fill":"freeze","values":"\n                                M101.368-73.685c0,12.164,0,15.18,0,28.519c0,22.702,0-13.661,0,8.304c0,14.48,0,18.233,0,30.512\n          c0,1.753-2.958,1.847-2.958,0c0-12.68,0-16.277,0-30.401c0-21.983,0,11.66,0-8.305c0-13.027,0-15.992,0-28.628\n          C98.411-75.883,101.368-75.592,101.368-73.685z\n                                ;\n                                M101.368,350.885c0,12.164,0,65.18,0,78.518c0,22.703,0-33.66,0-11.695c0,14.48,0,28.232,0,40.512\n          c0,1.753-2.958,1.847-2.958,0c0-12.68,0-26.277,0-40.402c0-21.982,0,31.66,0,11.695c0-13.027,0-65.992,0-78.627\n          C98.411,348.686,101.368,348.977,101.368,350.885z\n                                ;\n                                M128.38,447.567c37.626,6.312,39.303,13.658,26.833,12.833c-22.653-1.499-13.636-0.831-23.302-0.831\n          c-14.48,0-17.884,0-30.163,0c-2.087,0-2.068,0-3.915,0c-13.333,0-8.963,0-23.088,0c-11.668,0-14.062,5.995-27.532,1.164\n          c-12.629-4.529,38.667-3.167,46.833-17.333C100.077,432.94,105.546,443.736,128.38,447.567z\n                                ;\n                                M173.667,451.394c2.875,0,2.997,9.257,0,9.131c-22.662-0.956-32.09-0.956-41.756-0.956\n          c-14.48,0-17.884,0-30.163,0c-2.087,0-2.068,0-3.915,0c-13.333,0-8.963,0-23.088,0c-11.668,0-34.99-0.294-48.412,1.831\n          c-4.109,0.65-3.01-10.006,0-10.006C37.129,451.394,149.379,451.394,173.667,451.394z\n                                "}})]),_vm._v(" "),_c('path',{attrs:{"fill":"#a88679","d":"M173.667,21.571c-33.174,0-111.467,0-147.334,0c-4,0-4-16.002,0-16.002c39.836,0,105.982,0,147.334,0\n          C177.668,5.569,177.667,21.571,173.667,21.571z"}},[_c('animate',{attrs:{"id":"bizcocho_1","attributeName":"d","calcMode":"spline","keySplines":"0 0 1 1; 0 0 1 1; 0 0 1 1; 0.25 0 1 1; 0 0 1 1; 0.25 0 0.6 1","begin":"2s","dur":"0.8s","fill":"freeze","values":"\n                                M173.667,21.571c-33.174,0-111.467,0-147.334,0c-4,0-4-16.002,0-16.002c39.836,0,105.982,0,147.334,0\n          C177.668,5.569,177.667,21.571,173.667,21.571z\n                                ;\n                                M173.667,459.569c-33.197,16.002-110.782,16.002-147.334,0c-3.664-1.604,1.614-15.617,5.337-14.153\n          c40.702,16.002,94.289,16.104,136.505,0.103C171.917,444.1,177.271,457.832,173.667,459.569z\n                                ;\n                                M171.817,475.571c-39.361-3.001-105.438-2.571-143.556,0c-3.991,0.27-7.377-14.736-3.387-15.014\n          c41.553-2.888,104.421-3.121,150.51-0.233C179.378,460.574,175.806,475.875,171.817,475.571z\n                                ;\n                                M171.817,459.564c-38.8-12.188-104.504-13.762-143.556,0c-3.772,1.329-7.961-12.604-4.178-13.905\n          c40.864-14.064,105.114-15.52,151.918-0.973C179.822,445.874,175.634,460.762,171.817,459.564z\n                                ;\n                                M173.667,475.571c-46.376-5.005-105.924-4.003-147.334,0c-3.981,0.385-3.479-15.421,0.479-16.002\n          c43.087-6.327,97.705-7.083,146.855,0.438C177.621,460.613,177.644,476,173.667,475.571z\n                                ;\n                                M173.667,474.117c-46.376,1.866-105.638,2.01-147.334,0c-3.995-0.192-3.52-16.144,0.479-16.002\n          c43.794,1.55,96.341,1.541,145.723,0C176.532,457.99,177.663,473.956,173.667,474.117z\n                                ;\n                                M173.667,475.571c-46.512,0-105.486,0-147.334,0c-3.999,0-4-16.002,0-16.002c43.566,0,97.96,0,147.334,0\n          C177.667,459.569,177.666,475.571,173.667,475.571z\n                                "}})]),_vm._v(" "),_c('path',{attrs:{"fill":"#fefae9","d":"M104.812,113.216c0,3.119-2.164,5.67-4.812,5.67c-2.646,0-4.812-2.551-4.812-5.67c0-5.594,0-16.782,0-22.375\n        c0-5.143,0-15.427,0-20.568c0-7.333,0-21.998,0-29.33c0-5.523,0-16.569,0-22.092c0-3.295,0-9.885,0-13.181\n        C95.188,2.551,97.353,0,100,0c2.648,0,4.812,2.551,4.812,5.669c0,3.248,0,9.743,0,12.991c0,5.428,0,16.284,0,21.711\n        c0,7.618,0,22.854,0,30.472c0,4.952,0,14.854,0,19.807C104.812,96.292,104.812,107.576,104.812,113.216z"}},[_c('animate',{attrs:{"id":"crema","attributeName":"d","calcMode":"spline","keySplines":"0 0 1 1; 0 0 1 1; 0 0 1 1; 0.25 0 1 1; 0 0 1 1; 0 0 0.58 1","begin":"bizcocho_3.end","dur":"2s","fill":"freeze","values":"\n                                M104.812,113.216c0,3.119-2.164,5.67-4.812,5.67c-2.646,0-4.812-2.551-4.812-5.67c0-5.594,0-16.782,0-22.375\n        c0-5.143,0-15.427,0-20.568c0-7.333,0-21.998,0-29.33c0-5.523,0-16.569,0-22.092c0-3.295,0-9.885,0-13.181\n        C95.188,2.551,97.353,0,100,0c2.648,0,4.812,2.551,4.812,5.669c0,3.248,0,9.743,0,12.991c0,5.428,0,16.284,0,21.711\n        c0,7.618,0,22.854,0,30.472c0,4.952,0,14.854,0,19.807C104.812,96.292,104.812,107.576,104.812,113.216z\n                                ;\n                                M104.812,405.897c0,3.119-2.164,5.67-4.812,5.67c-2.646,0-4.812-2.551-4.812-5.67c0-5.594,0-16.782,0-22.376\n        c0-5.143,0-15.426,0-20.568c0-7.332,0-21.997,0-29.33c0-5.522,0-16.568,0-22.092c0-3.295,0-9.885,0-13.181\n        c0-3.118,2.165-5.669,4.812-5.669c2.648,0,4.812,2.551,4.812,5.669c0,3.247,0,9.743,0,12.991c0,5.428,0,16.283,0,21.711\n        c0,7.618,0,22.854,0,30.473c0,4.951,0,14.854,0,19.807C104.812,388.972,104.812,400.256,104.812,405.897z\n                                ;\n                                M111.873,411.567c-3.119,0-9.226,0-11.874,0c-2.646,0-7.748,0-10.867,0c-7.086,0-12.698,0-18.292,0\n        c-6.592,0-12.871,7.371-19.166,3.008c-10.043-6.961-7.776-10.169,2.991-17.745c12.61-8.873,27.713,1.994,25.919-7.531\n        c-2.589-13.742,11.008-14.513,11.365-17.789c0.441-4.051,4.235-11.107,8.051-8.175c3.113,2.393,1.007,8.008,0,13.159\n        c-1.871,9.569,8.058,2.113,9.494,14.155c2.592,21.732,21.184-0.675,29.309,7.976c5.216,5.553,18.413,5.552,15.426,12.942\n        c-3.131,7.745-15.825-4.369-23.8,2.903C126.261,418.271,118.301,411.567,111.873,411.567z\n                                ;\n                                M111.873,411.567c-3.119,0-9.226,0-11.874,0c-2.646,0-9.734,4.069-12.853,4.069\n        c-7.086,0-10.712-4.069-16.306-4.069c-6.592,0-12.12,6.013-19.166,3.008c-7.053-3.008-7.458,2.026-18.659,1.165\n        c-6.832-0.525-7.522-3.034-7.533-6.265c-0.037-10.336,22.073-2.452,36.613-2.628c10.234-0.124,19.856-1.439,37.905-2.102\n        c16.642-0.61,32.699,1.552,46.009,1.927c12.438,0.351,29.663-8.99,31.532,3.315c0.773,5.093-5.605,3.342-11.211,9.579\n        c-5.093,5.667-7.59-4.605-12.965-3.832c-8.269,1.189-14.962-8.537-22.937-1.265C126.261,418.271,118.301,411.567,111.873,411.567z\n                                ;\n                                M110.946,413.652c-2.904-1.137-8.405-2.748-12.446-0.97c-6.099,2.685-7.273,10.358-13.253,8.242\n        c-7.843-2.775-8.953-5.008-14.546-5.01c-24.653-0.011-4.849,26.507-18.264,26.507c-12.377,0,5.791-33.537-19.422-26.682\n        c-7.703,2.095-9.806-0.942-9.817-4.173c-0.037-10.336,24.357-4.544,38.897-4.72c10.234-0.124,19.856-1.439,37.905-2.102\n        c16.642-0.61,32.699,1.552,46.009,1.927c12.438,0.351,28.973-8.865,31.532,3.315c1.449,6.896,0.318,15.624-3.874,15.624\n        c-7.619,0-1.788-15.192-19.243-7.111c-7.581,3.51-15.963-9.738-26.669,1.066C120.644,426.744,118.381,416.561,110.946,413.652z\n                                ;\n                                M111.547,413.9c-2.969-0.956-8.775-0.949-13.167-0.5c-14.667,1.5-8.325,16.508-14.667,16.666\n        c-6.667,0.166-0.167-13.5-13.013-14.151c-30.471-1.545-5.572,46.651-18.987,46.651c-12.377,0,10.333-50.166-18.667-44.5\n        c-7.835,1.531-9.537-1.417-9.548-4.647c-0.037-10.336,23.675-5.177,38.215-5.353c10.234-0.124,20.618-1.671,38.667-2.333\n        c16.642-0.61,32.023,1.458,45.333,1.833c12.438,0.351,33.819-8.431,33.199,4.001c-0.532,10.666,0.414,26.166-5.245,25.833\n        c-7.606-0.447-2.954-31.5-19.243-18.899c-7.985,6.177-17.658-5.969-27.377,5.732C118.88,434.066,121.38,417.067,111.547,413.9z\n                                ;\n                                M111.547,415.233c-6.667-0.834-9.667,4.667-13.833,3.333c-19.649-6.291-8.158,22.176-14.5,22.334\n        c-6.667,0.166,2.833-18-13.333-22.167c-29.544-7.615-9.667,43.833-20.167,43.833c-10.333,0,8.004-55.006-16.833-39\n        c-7.5,4.833-9.508-3.78-9.299-7.004c0.799-12.329,23.592-7.153,38.132-7.329c10.234-0.124,20.238-1.505,38.287-2.167\n        c16.642-0.61,32.903,1.125,46.213,1.5c12.438,0.351,35.058-5.579,31.863,6.451c-5.532,20.833,1.25,28.216-4.409,27.883\n        c-7.606-0.447-6.058-37.895-20.62-23.333c-10.167,10.166-15.972-0.747-25,12C119.547,443.568,121.798,416.515,111.547,415.233z\n                                "}})]),_vm._v(" "),_c('rect',{staticClass:"come",attrs:{"x":"10","y":"475.571","fill":"#fefae9","width":"180","height":"4"}})])]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("\n      机智小宝贝\n  ")]),_vm._v(" "),_c('div',{staticClass:"happy"},[_c('img',{attrs:{"src":_vm.png_url}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"button-style1",staticStyle:{"top":"60%","width":"100%"}},[_c('div',{staticClass:"lk1",attrs:{"STYLE":"font-size: 20px;margin-bottom: 20px;"}},[_vm._v("\n          你喜欢吗?\n      ")]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"}},[_c('tr',[_c('td',[_c('a',{staticClass:"lk1",staticStyle:{"float":"right"},attrs:{"href":"javascript:void(0)"},on:{"click":_vm.btnclick}},[_vm._m(2)])]),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_vm._m(4)])}
var Cake_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"velas"},[_c('div',{staticClass:"fuego"}),_vm._v(" "),_c('div',{staticClass:"fuego"}),_vm._v(" "),_c('div',{staticClass:"fuego"}),_vm._v(" "),_c('div',{staticClass:"fuego"}),_vm._v(" "),_c('div',{staticClass:"fuego"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-style1",staticStyle:{"top":"60%","width":"100%"},attrs:{"id":"isLike","align":"center"}},[_c('div',{staticClass:"lk1",attrs:{"STYLE":"font-size: 20px; margin-left: 20px;margin-right: 20px"}},[_vm._v("\n          这一刻，有我最深的思念。让云捎去满心的祝福，点缀你甜蜜的梦，愿你度过一个温馨浪漫的生日！\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link1"},[_c('div',{staticClass:"bt1",attrs:{"STYLE":"font-size: 20px"}},[_vm._v("\n                              我很喜欢\n                          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('a',{staticClass:"lk1 no-like",attrs:{"href":"#"}},[_c('div',{staticClass:"link1"},[_c('div',{staticClass:"bt1",attrs:{"STYLE":"font-size: 20px"}},[_vm._v("\n                              我不喜欢\n                          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"bg-bubbles"},[_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li')])}]
var Cake_esExports = { render: Cake_render, staticRenderFns: Cake_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Cake = (Cake_esExports);
// CONCATENATED MODULE: ./src/components/Cake.vue
function Cake_injectStyle (ssrContext) {
  __webpack_require__("axha")
}
var Cake_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Cake___vue_template_functional__ = false
/* styles */
var Cake___vue_styles__ = Cake_injectStyle
/* scopeId */
var Cake___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Cake___vue_module_identifier__ = null
var Cake_Component = Cake_normalizeComponent(
  components_Cake,
  selectortype_template_index_0_src_components_Cake,
  Cake___vue_template_functional__,
  Cake___vue_styles__,
  Cake___vue_scopeId__,
  Cake___vue_module_identifier__
)

/* harmony default export */ var src_components_Cake = (Cake_Component.exports);

// EXTERNAL MODULE: ./src/assets/img/1.jpg
var img_1 = __webpack_require__("Erzt");
var img_1_default = /*#__PURE__*/__webpack_require__.n(img_1);

// EXTERNAL MODULE: ./src/assets/img/2.jpg
var img_2 = __webpack_require__("Mn6R");
var img_2_default = /*#__PURE__*/__webpack_require__.n(img_2);

// EXTERNAL MODULE: ./src/assets/img/3.jpg
var img_3 = __webpack_require__("ihpy");
var img_3_default = /*#__PURE__*/__webpack_require__.n(img_3);

// EXTERNAL MODULE: ./src/assets/img/4.jpg
var img_4 = __webpack_require__("CtaL");
var img_4_default = /*#__PURE__*/__webpack_require__.n(img_4);

// EXTERNAL MODULE: ./src/assets/img/5.jpg
var img_5 = __webpack_require__("8FcD");
var img_5_default = /*#__PURE__*/__webpack_require__.n(img_5);

// EXTERNAL MODULE: ./src/assets/img/6.jpg
var img_6 = __webpack_require__("DeB9");
var img_6_default = /*#__PURE__*/__webpack_require__.n(img_6);

// EXTERNAL MODULE: ./src/assets/img/7.jpg
var img_7 = __webpack_require__("7jQq");
var img_7_default = /*#__PURE__*/__webpack_require__.n(img_7);

// EXTERNAL MODULE: ./src/assets/img/8.jpg
var img_8 = __webpack_require__("MNtS");
var img_8_default = /*#__PURE__*/__webpack_require__.n(img_8);

// EXTERNAL MODULE: ./src/assets/img/9.jpg
var img_9 = __webpack_require__("pfBO");
var img_9_default = /*#__PURE__*/__webpack_require__.n(img_9);

// EXTERNAL MODULE: ./src/assets/img/10.jpg
var _0 = __webpack_require__("TV5D");
var _0_default = /*#__PURE__*/__webpack_require__.n(_0);

// EXTERNAL MODULE: ./src/assets/img/11.jpg
var _1 = __webpack_require__("s065");
var _1_default = /*#__PURE__*/__webpack_require__.n(_1);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Img.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ var Img = ({
  components: {},
  data: function data() {
    return {
      user: '',
      leng: 0,
      index: 0,
      imgel: [],
      imgurl: {
        img1: img_1_default.a,
        img2: img_2_default.a,
        img3: img_3_default.a,
        img4: img_4_default.a,
        img5: img_5_default.a,
        img6: img_6_default.a,
        img7: img_7_default.a,
        img8: img_8_default.a,
        img9: img_9_default.a,
        img10: _0_default.a,
        img11: _1_default.a
      }
    };
  },

  methods: {
    btnclick: function btnclick() {
      jquery_default()('audio#img-music')[0].pause();
      jquery_default()('audio#memory-music')[0].play();
      var url = '/memories';
      this.$router.push({ path: url });
    },
    feiru: function feiru() {
      if (this.leng === 0 && this.index === 0) {
        return;
      }
      if (this.leng > this.index) {
        setTimeout(this.feirucore, 4000);
      } else {
        setTimeout(this.showEndBtn, 4000);
      }
    },
    feirucore: function feirucore() {
      this.animateFct();
      console.log(this.index);
      this.index++;
      this.feiru();
    },
    showEndBtn: function showEndBtn() {
      jquery_default()('.end').fadeIn(3000);
    },
    animateFct: function animateFct() {
      var i = this.index;
      var li = this.imgel;
      var randTBArr = ['top', 'bottom'];
      var randLRArr = ['right', 'left'];
      var data = {};
      var c = Math.floor(Math.random() * 2 + 1);
      li.eq(i).css(randTBArr[c - 1], '-100%');
      var d = Math.floor(Math.random() * 2 + 1);
      li.eq(i).css(randLRArr[d - 1], '-100%');
      li.eq(i).css('z-index', i);
      var n = Math.floor(Math.random() * 30 + -30);
      li.eq(i).css({ transform: 'rotate(' + n + 'deg)' });
      li.eq(i).find('img').css({ width: '250px', height: '350px' });
      li.eq(i).show();
      if (parseInt(li.eq(i).css('top')) < 0) {
        data.top = parseInt(Math.random() * 20 + 5) + '%';
      }
      if (parseInt(li.eq(i).css('left')) < 0) {
        data.left = parseInt(Math.random() * 15 + 5) + '%';
      }
      if (parseInt(li.eq(i).css('right')) < 0) {
        data.right = parseInt(Math.random() * 15 + 5) + '%';
      }
      if (parseInt(li.eq(i).css('bottom')) < 0) {
        data.bottom = parseInt(Math.random() * 30 + 15) + '%';
      }
      li.eq(i).stop().animate(data, 3000);
    }
  },
  mounted: function mounted() {
    var li = jquery_default()('.img-li');
    this.leng = li.length;
    this.imgel = li;
    this.feiru();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Img.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ var components_Img = ({
  components: {},
  data: function data() {
    return {
      user: '',
      leng: 0,
      index: 0,
      imgel: [],
      imgurl: {
        img1: img_1_default.a,
        img2: img_2_default.a,
        img3: img_3_default.a,
        img4: img_4_default.a,
        img5: img_5_default.a,
        img6: img_6_default.a,
        img7: img_7_default.a,
        img8: img_8_default.a,
        img9: img_9_default.a,
        img10: _0_default.a,
        img11: _1_default.a
      }
    };
  },

  methods: {
    btnclick: function btnclick() {
      jquery_default()('audio#img-music')[0].pause();
      jquery_default()('audio#memory-music')[0].play();
      var url = '/memories';
      this.$router.push({ path: url });
    },
    feiru: function feiru() {
      if (this.leng === 0 && this.index === 0) {
        return;
      }
      if (this.leng > this.index) {
        setTimeout(this.feirucore, 4000);
      } else {
        setTimeout(this.showEndBtn, 4000);
      }
    },
    feirucore: function feirucore() {
      this.animateFct();
      console.log(this.index);
      this.index++;
      this.feiru();
    },
    showEndBtn: function showEndBtn() {
      jquery_default()('.end').fadeIn(3000);
    },
    animateFct: function animateFct() {
      var i = this.index;
      var li = this.imgel;
      var randTBArr = ['top', 'bottom'];
      var randLRArr = ['right', 'left'];
      var data = {};
      var c = Math.floor(Math.random() * 2 + 1);
      li.eq(i).css(randTBArr[c - 1], '-100%');
      var d = Math.floor(Math.random() * 2 + 1);
      li.eq(i).css(randLRArr[d - 1], '-100%');
      li.eq(i).css('z-index', i);
      var n = Math.floor(Math.random() * 30 + -30);
      li.eq(i).css({ transform: 'rotate(' + n + 'deg)' });
      li.eq(i).find('img').css({ width: '250px', height: '350px' });
      li.eq(i).show();
      if (parseInt(li.eq(i).css('top')) < 0) {
        data.top = parseInt(Math.random() * 20 + 5) + '%';
      }
      if (parseInt(li.eq(i).css('left')) < 0) {
        data.left = parseInt(Math.random() * 15 + 5) + '%';
      }
      if (parseInt(li.eq(i).css('right')) < 0) {
        data.right = parseInt(Math.random() * 15 + 5) + '%';
      }
      if (parseInt(li.eq(i).css('bottom')) < 0) {
        data.bottom = parseInt(Math.random() * 30 + 15) + '%';
      }
      li.eq(i).stop().animate(data, 3000);
    }
  },
  mounted: function mounted() {
    var li = jquery_default()('.img-li');
    this.leng = li.length;
    this.imgel = li;
    this.feiru();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ae520f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Img.vue
var Img_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-container"},[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"img-ul"},[_c('li',{staticClass:"img-li"},[_c('img',{attrs:{"src":_vm.imgurl.img1,"alt":""}})]),_vm._v(" "),_c('li',{staticClass:"img-li"},[_c('img',{attrs:{"src":_vm.imgurl.img2,"alt":""}})]),_vm._v(" "),_c('li',{staticClass:"img-li"},[_c('img',{attrs:{"src":_vm.imgurl.img3,"alt":""}})]),_vm._v(" "),_c('li',{staticClass:"img-li"},[_c('img',{attrs:{"src":_vm.imgurl.img4,"alt":""}})]),_vm._v(" "),_c('li',{staticClass:"img-li"},[_c('img',{attrs:{"src":_vm.imgurl.img5,"alt":""}})]),_vm._v(" "),_c('li',{staticClass:"img-li"},[_c('img',{attrs:{"src":_vm.imgurl.img6,"alt":""}})]),_vm._v(" "),_c('li',{staticClass:"img-li"},[_c('img',{attrs:{"src":_vm.imgurl.img7,"alt":""}})]),_vm._v(" "),_c('li',{staticClass:"img-li"},[_c('img',{attrs:{"src":_vm.imgurl.img8,"alt":""}})]),_vm._v(" "),_c('li',{staticClass:"img-li"},[_c('img',{attrs:{"src":_vm.imgurl.img9,"alt":""}})]),_vm._v(" "),_c('li',{staticClass:"img-li"},[_c('img',{attrs:{"src":_vm.imgurl.img10,"alt":""}})]),_vm._v(" "),_c('li',{staticClass:"img-li"},[_c('img',{attrs:{"src":_vm.imgurl.img11,"alt":""}})])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"end",on:{"click":_vm.btnclick}},[_vm._v("打开礼物")])])}
var Img_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"htmleaf-container"},[_c('div',{staticClass:"wrapper"},[_c('ul',{staticClass:"bg-bubbles"},[_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li')])])])}]
var Img_esExports = { render: Img_render, staticRenderFns: Img_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Img = (Img_esExports);
// CONCATENATED MODULE: ./src/components/Img.vue
function Img_injectStyle (ssrContext) {
  __webpack_require__("E3o5")
}
var Img_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Img___vue_template_functional__ = false
/* styles */
var Img___vue_styles__ = Img_injectStyle
/* scopeId */
var Img___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Img___vue_module_identifier__ = null
var Img_Component = Img_normalizeComponent(
  components_Img,
  selectortype_template_index_0_src_components_Img,
  Img___vue_template_functional__,
  Img___vue_styles__,
  Img___vue_scopeId__,
  Img___vue_module_identifier__
)

/* harmony default export */ var src_components_Img = (Img_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Memories.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Memories = ({
  components: {},
  data: function data() {
    return {
      options: {
        navigation: true,
        navigationPosition: 'left',
        // navigationColor: ['#fff'],
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        sectionSelector: '.section',
        afterLoad: this.afterLoad
      }
    };
  },

  methods: {
    afterLoad: function afterLoad(origin, destination, direction) {
      console.log('After load....');
      console.log(destination);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Memories.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_Memories = ({
  components: {},
  data: function data() {
    return {
      options: {
        navigation: true,
        navigationPosition: 'left',
        // navigationColor: ['#fff'],
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        sectionSelector: '.section',
        afterLoad: this.afterLoad
      }
    };
  },

  methods: {
    afterLoad: function afterLoad(origin, destination, direction) {
      console.log('After load....');
      console.log(destination);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bad52108","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Memories.vue
var Memories_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mem-container"},[_c('div',{staticClass:"bgcolor"},[_c('full-page',{staticStyle:{"z-index":"100"},attrs:{"options":_vm.options}},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"ly-box01"},[_c('div',{staticClass:"ly-txt01"},[_c('p',{staticClass:"ly-stxt01"},[_vm._v("致机智:")]),_vm._v(" "),_c('p',{staticClass:"ly-stxt02"},[_vm._v("启信佳!")]),_vm._v(" "),_c('p',{staticClass:"ly-stxt03"},[_vm._v("白云苍狗,岁月匆匆。只是一样的初中,却能与你从相识到相熟,缘,妙不可言。")]),_vm._v(" "),_c('p',{staticClass:"ly-stxt04"},[_vm._v("不知不觉高考也过去了3年,或许每年高考时节我总会回想过去,想起那些青春往事。")]),_vm._v(" "),_c('p',{staticClass:"ly-stxt05"},[_vm._v("但是现在很多时候,我已经慢慢的淡忘了很多事情,也变得不那么爱回忆。")]),_vm._v(" "),_c('p',{staticClass:"ly-stxt06"},[_vm._v("我们都在各自长大变化,两个人可能很少联系,慢慢的,感情也就淡了。")]),_vm._v(" "),_c('p',{staticClass:"ly-stxt07"},[_vm._v("但我知道的是,友情的延续,跟现实没有太多的关系,")]),_vm._v(" "),_c('p',{staticClass:"ly-stxt08"},[_vm._v("有关系的,不过是两颗简单而不计较的心。")]),_vm._v(" "),_c('p',{staticClass:"ly-stxt09"},[_vm._v("真正的情谊,永远不需要刻意用联系去维系。")]),_vm._v(" "),_c('p',{staticClass:"ly-stxt10"},[_vm._v("生活需要仪式感,需要不经意间的感动与开心。")]),_vm._v(" "),_c('p',{staticClass:"ly-stxt11"},[_vm._v("以此形式,愿你在充满希望的季节中播种,在秋日的喜悦里收获!")]),_vm._v(" "),_c('p',{staticClass:"ly-stxt12"},[_vm._v("祝你：生日快乐！")]),_vm._v(" "),_c('p',{staticClass:"ly-stxt13"})])])]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"timeline"}),_vm._v(" "),_c('div',{staticClass:"timepoint21"}),_vm._v(" "),_c('div',{staticClass:"ly-box21"},[_c('div',{staticClass:"ly-txt21"},[_vm._v("\n              2022-07-18\n            ")]),_vm._v(" "),_c('div',{staticClass:"ly-txt22"},[_c('p',[_vm._v("好的,客套话说完了。")]),_vm._v(" "),_c('p',[_vm._v("你知道的,我不是一个话痨")]),_vm._v(" "),_c('p',[_vm._v("这个时间点,要进入强化阶段了啊！！！")]),_vm._v(" "),_c('p',[_vm._v("考研顺利,祝你早日进入梦中情校!")]),_vm._v(" "),_c('p',[_vm._v("(实在考不上就来广工,在广工等你。)")]),_vm._v(" "),_c('p',[_vm._v("生日快乐!")])]),_vm._v(" "),_c('div',{staticClass:"ly-imgbox21"},[_c('img',{staticClass:"ly-img21",attrs:{"src":__webpack_require__("7jQq")}})])]),_vm._v(" "),_c('div',{staticClass:"ly-triangle21"})])]),_vm._v(" "),_vm._m(0)],1)])}
var Memories_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"bg-bubbles"},[_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li')])}]
var Memories_esExports = { render: Memories_render, staticRenderFns: Memories_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Memories = (Memories_esExports);
// CONCATENATED MODULE: ./src/components/Memories.vue
function Memories_injectStyle (ssrContext) {
  __webpack_require__("LeiF")
}
var Memories_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Memories___vue_template_functional__ = false
/* styles */
var Memories___vue_styles__ = Memories_injectStyle
/* scopeId */
var Memories___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Memories___vue_module_identifier__ = null
var Memories_Component = Memories_normalizeComponent(
  components_Memories,
  selectortype_template_index_0_src_components_Memories,
  Memories___vue_template_functional__,
  Memories___vue_styles__,
  Memories___vue_scopeId__,
  Memories___vue_module_identifier__
)

/* harmony default export */ var src_components_Memories = (Memories_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js





var routes = [{
  path: '/',
  component: src_components_Login
}, {
  path: '/cake',
  name: 'Cake',
  component: src_components_Cake
}, {
  path: '/img',
  name: 'Img',
  component: src_components_Img
}, {
  path: '/memories',
  name: 'Memories',
  component: src_components_Memories
}];

/* harmony default export */ var router = (routes);
// EXTERNAL MODULE: ./node_modules/vue-fullpage.js/dist/vue-fullpage.js
var vue_fullpage = __webpack_require__("9yT1");
var vue_fullpage_default = /*#__PURE__*/__webpack_require__.n(vue_fullpage);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
vue_esm["a" /* default */].use(vue_fullpage_default.a);

var main_router = new vue_router_esm["a" /* default */]({
  routes: router
});

fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: main_router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "TV5D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/10.bc55c75.jpg";

/***/ }),

/***/ "axha":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fSgI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1.226c18f.mp3";

/***/ }),

/***/ "ihpy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.a68fb29.jpg";

/***/ }),

/***/ "ili8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m2cP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2.280d445.mp3";

/***/ }),

/***/ "pfBO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9.35f0769.jpg";

/***/ }),

/***/ "s065":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/11.c9c2500.jpg";

/***/ }),

/***/ "yFNT":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAtgAAACGBAMAAAAV5uCYAAAAG1BMVEX///8/Pz8fHx+/v79/f39fX1+fn5/f398AAADmSETKAAAAAXRSTlMAQObYZgAABKVJREFUeJzt2stv20YQB+Dhc3VUFLvWkZLrmEcmNVAdCbVBeVTTpOaRNlBUR8ppah1DPflnd2eX1KuBSQn2IdLvO4wJeUcgVqvhLCkiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+K78Wz1EJCT6k+TFT+WYuakMzqx64H1I0cSfvvT5HDPL58luLKtH+sFontrZi5/REXPU7A2blQOt3OqkMn77v+mzntSxMhcc47ByoJ31QtqZbBEUB1+SZz6t49RTBcSvXplG9kZGd6uMDAfFQY18IIq4gFiT6oGNnJexsXUljYuVLWrkA1E7kcGu0Yz0VL0Zb11Jy5ri1siHYr7MGs1IPFjHglXWFAcNYR3unOPYqx6pyvJ2vVl15+bX5z2rI6XXZBRWDrTVp/Jwvfna6gsxru4cQV72PI7t6mZizJ+K8IPN13pecRAlz3tWR2oYUr1mou3R9sKW0x6VBbzGhwXygsfTVKOZsLml5i1kyZSVo12uc3R+dQhViWs0EzdRsF3a5XZSlJ2fhc6vDldNsy7cTxHNNtHokg8t/Yqc/NVu0kbnV4ep2gi+6fE05+e5LCLqMNKvtNH57auXcIyDimF0Zy/IyW/58F6/kqHz21dLxW7VMHEpF6/w82T1CpfpVec3TL6RAzusTG0L51Xj7GZPLt4v+fpC2M/O151fjM6vBiObfPwprb6+jZM4kX9G+WpWuUyvOr/KbwZIvcHwUyvPc7m037c+yKritpIyRoFY3buOHnWX1w7J8Oju86Uq07n4EMoS83uLvxkqfzMHdrRT65pE70LuDRNZha35nZgWUS7X9Y3XK31nRH44/Lyg+zDjltvKRv94RO8CbtNV/lYObOOd433K1zfxhoylnCmPZkWU253xohgnFqauNI1Q1g6R/TDjDbo9uzC+kvy0ZNT5mzmwg2uB3eTrmymXrCdLeCBmRXQXFJetnb2U/1QJgdw1WllzyRt0Y5KMPbmk+W10/mYO7Ojy9e6MW+YoFX5I4w7Pl47OUnS9YpzT9BN10Of733YepNzANDK+jdVXlVznb+ZASbcRhrqH9/B5wcXWyQMaTrkY6Gh6TnRbDDd/1XearCk5C5d//CD3OGlvSfFjeEVuHjzq/M0cKNgZz7ZoqUbOPZff/Dm998V17PHOXcfG4K/hq2K8GauSLeRO01y+5fptLJ1AttmZk8xp5IuBzt/MgYIVZ3+TuC8WYVtW7s7NIH+X+L+IDpGOjdtmu7x73ch/82WDyNv1xrzJlb4x/citzOwTtcSFfxfo/M0cWLlpvWr9URyPE7nh/pHi1yJ/2+IbpxzJvkon5RbGXBh5Pjnjr4Ns7fh+ij0JqEOiG9LoPI1e6/ytHHiafvjrlpv39SMFUXsG8ZuGuozpOtLuT0TqOSTnNOlnCOWThEO6OHR+tfUG6yhbQvUseD+H5Jwo/QyhfJJwPq58pPA/h+ScKH8jkrvs7/0Gh+ScKP0MoXySYDbP9n6HQ3JOlL1YR3md/NPb+x0OyTlRxsU6Ejmd/bcnh+QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA9+Q/CIvf3KvII60AAAAASUVORK5CYII="

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.920433de692238885a13.js